import { ref, computed, resolveComponent, createElementBlock, openBlock, Fragment, createVNode, createBlock, createCommentVNode, mergeProps, unref, withModifiers, isRef, withCtx, createElementVNode, toDisplayString } from "vue";
import { useRouter } from "vue-router";
import { useBanza } from "../../plugins/banza/global.js";
import { VSnackbar } from "vuetify/components/VSnackbar";
const _hoisted_1 = { class: "fs-16" };
const _sfc_main = {
  __name: "LinkButton",
  props: {
    link: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: "Текст кнопки"
    },
    icon: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: null
    },
    textColor: {
      type: String,
      default: null
    },
    iconColor: {
      type: String,
      default: null
    },
    iconSize: {
      type: [String, Number],
      default: 16
    },
    showMode: {
      type: String,
      default: null
    },
    clickAction: {
      type: String,
      default: null
    },
    preset: {
      type: String,
      default: null
    }
  },
  emits: ["click"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const banza = useBanza();
    const router = useRouter();
    const props = __props;
    const snackbar = ref(false);
    const disabled = ref(false);
    const loading = ref(false);
    const openLink = async () => {
      let callBack = null;
      if (props.link) {
        if (props.clickAction === "copyToClipboard") {
          banza.copyTextToClipboard(props.link);
          snackbar.value = true;
        } else {
          if (props.clickAction !== "openInNewTab") {
            const url = new URL(props.link, window.location.origin);
            if (url.origin === window.location.origin) {
              callBack = () => {
                router.push(url.pathname + url.search);
              };
            }
          }
          if (!callBack) {
            if (props.clickAction === "openInNewTab") {
              window.open(props.link, "_blank");
            } else {
              callBack = () => {
                window.open(props.link, "_self");
              };
            }
          }
        }
      }
      if (callBack) {
        callBack();
      }
      emit("click");
    };
    const btnAttrs = computed(() => {
      const attrs = {};
      if (props.text) {
        attrs.text = props.text;
      }
      if (props.color) {
        attrs.color = props.color;
      }
      if (props.icon) {
        attrs.iconName = props.icon;
      }
      if (props.iconSize) {
        attrs.iconSize = props.iconSize;
      }
      if (props.preset) {
        attrs.preset = props.preset;
      }
      return attrs;
    });
    const settings = computed(() => {
      var config = {};
      if (props.textColor) {
        config = {
          slots: {
            text: { style: `color: ${props.textColor}` }
          }
        };
      }
      var iconAttrs = null;
      if (props.iconColor) {
        iconAttrs = {
          color: props.iconColor
        };
      }
      if (props.showMode === "right") {
        iconAttrs = {
          ...iconAttrs,
          right: true
        };
      }
      if (iconAttrs) {
        config.slots = {
          ...config.slots,
          icon: {
            attrs: {
              ...iconAttrs
            }
          }
        };
      }
      return config;
    });
    return (_ctx, _cache) => {
      const _component_b_btn = resolveComponent("b-btn");
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(_component_b_btn, mergeProps({
          width: "unset",
          settings: unref(settings),
          disabled: unref(disabled) || unref(loading),
          loading: unref(loading)
        }, unref(btnAttrs), {
          onClick: withModifiers(openLink, ["stop"])
        }), null, 16, ["settings", "disabled", "loading"]),
        unref(snackbar) ? (openBlock(), createBlock(VSnackbar, {
          key: 0,
          modelValue: unref(snackbar),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => isRef(snackbar) ? snackbar.value = $event : null),
          timeout: 1500,
          color: "primary"
        }, {
          actions: withCtx(() => [
            createVNode(_component_b_btn, {
              preset: "closeMini",
              onClick: _cache[0] || (_cache[0] = ($event) => snackbar.value = false)
            })
          ]),
          default: withCtx(() => [
            createElementVNode("span", _hoisted_1, toDisplayString(_ctx.$t("pages.news.edit.copied")), 1)
          ]),
          _: 1
        }, 8, ["modelValue"])) : createCommentVNode("", true)
      ], 64);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
